/**
 * Accordions
 *
 * @return {void}
 */

$('.js-accordion').not('.is-active').find('.js-accordion-content').hide();

const accordion = (element) => {
  $(element).on('click', function(event) {
    event.preventDefault();

    const $this = $(this);
    const $accordion = $this.closest('.js-accordion');
    const $accordions = $this.closest('.js-accordions').find('> .js-accordion');

    $accordions.not($accordion).removeClass('is-active');
    $accordions
      .find('> .js-accordion-content')
      .not($accordion.find('> .js-accordion-content'))
      .slideUp();
    $accordion.toggleClass('is-active');
    $accordion.find('> .js-accordion-content').slideToggle();
  });
};

accordion('.js-accordion > a');

/**
 * Accordions for mobile only
 *
 * @param {}
 * @return {void}
 */

$('.js-acc-mobile .js-acc-btn').on('click', function(e) {
  e.preventDefault();

  if ($(window).outerWidth() < 768) {
    $(this)
      .closest('.js-acc-head')
      .siblings('.js-acc-body')
      .slideToggle()
        .closest('.js-acc-mobile')
        .toggleClass('is-opened');
  }
});

$(window).on('load resize orientationchange', function() {
  if ($(window).outerWidth() > 767) {
    $('.js-acc-mobile').each(function(e) {
      $(this)
        .removeClass('is-opened')
          .find('.js-acc-body')
          .css('display', 'block');
    });
  }
  if ($(window).outerWidth() < 768) {
    $('.js-acc-mobile:not(.is-opened)').each(function() {
      $(this)
        .find('.js-acc-body')
        .css('display', 'none');
    });
  }
});
